import { render } from "./VisitTypeIcon.vue?vue&type=template&id=71143747&scoped=true"
import script from "./VisitTypeIcon.vue?vue&type=script&lang=js"
export * from "./VisitTypeIcon.vue?vue&type=script&lang=js"

import "./VisitTypeIcon.vue?vue&type=style&index=0&id=71143747&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71143747"]])

export default __exports__